/**
 * Application Routes Schema
 * Single source of truth for all route paths
 * Import and use these constants instead of hardcoding route strings
 */

export const ROUTES = {
  HOME: "/",
  CONTACT_US: "/contact-us",
  PRIVACY_POLICY: "/privacy",
  TERMS_CONDITIONS: "/terms",
  PRODUCTS: "/products",
  PRODUCT_DETAIL: "/products/:id",
  CART: "/cart",
  PAYMENT_SUCCESS: "/payment-success",

  // Root
  ROOT: "/",
} as const;

/**
 * Type-safe route type for navigation
 */
export type RouteKey = typeof ROUTES[keyof typeof ROUTES][keyof typeof ROUTES[keyof typeof ROUTES]];
